import { IconType } from '../../../../components/icons';
import { IconApple } from '../../../../components/icons/IconApple';
import { IconAppleWhite } from '../../../../components/icons/IconAppleWhite';
import { IconBriefcase } from '../../../../components/icons/IconBriefcase';
import { IconBriefcaseWhite } from '../../../../components/icons/IconBriefcaseWhite';
import { IconCoins } from '../../../../components/icons/IconCoins';
import { IconCoinsWhite } from '../../../../components/icons/IconCoinsWhite';
import { IconGraduationCap } from '../../../../components/icons/IconGraduationCap';
import { IconGraduationCapWhite } from '../../../../components/icons/IconGraduationCapWhite';
import { IconHeartHandShake } from '../../../../components/icons/IconHeartHandShake';
import { IconHeartHandShakeWhite } from '../../../../components/icons/IconHeartHandShakeWhite';
import { IconHeartPulse } from '../../../../components/icons/IconHeartPulse';
import { IconHeartPulseWhite } from '../../../../components/icons/IconHeartPulseWhite';
import { IconSprout } from '../../../../components/icons/IconSprout';
import { IconSproutWhite } from '../../../../components/icons/IconSproutWhite';
import { IconUsers } from '../../../../components/icons/IconUsers';
import { IconUsersWhite } from '../../../../components/icons/IconUsersWhite';
import { HubSurveyResultSupportArea } from '../../../../graphQL';

type SupportAreaIcons = {
  default: IconType;
  white: IconType;
};

export const supportAreaIconMap: Record<
  HubSurveyResultSupportArea['supportArea'],
  SupportAreaIcons
> = {
  BasicNeeds: { default: IconApple, white: IconAppleWhite },
  MentalHealth: { default: IconSprout, white: IconSproutWhite },
  PhysicalHealth: { default: IconHeartPulse, white: IconHeartPulseWhite },
  Finances: { default: IconCoins, white: IconCoinsWhite },
  Academics: { default: IconGraduationCap, white: IconGraduationCapWhite },
  FamilyAndRelationships: { default: IconUsers, white: IconUsersWhite },
  SenseOfBelonging: { default: IconHeartHandShake, white: IconHeartHandShakeWhite },
  WorkAndCareer: { default: IconBriefcase, white: IconBriefcaseWhite },
};
